var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookMarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92 3h5.261c.535 0 .98 0 1.345.03.38.03.736.098 1.074.27a2.75 2.75 0 011.202 1.202c.171.337.239.693.27 1.073.03.365.03.81.03 1.345V18.252a.75.75 0 01-1.086.67l-4.37-2.184c-.563-.282-.717-.351-.865-.38a1.253 1.253 0 00-.46 0c-.149.029-.302.098-.866.38l-4.37 2.184A.75.75 0 013 18.252V6.92c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073A2.75 2.75 0 014.502 3.3c.337-.172.693-.24 1.073-.27C5.94 3 6.385 3 6.92 3zm5.61 5.542a.625.625 0 10-.883-.883l-2.821 2.82-1.009-1.008a.625.625 0 10-.884.884l1.45 1.45c.245.244.64.244.884 0l3.263-3.263z"
  })));
}
export default SvgBookMarkFilled;